// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1fmzH","topBottomGutter":"Layout_topBottomGutter__WXdte"};